import type { FormikValues } from 'formik'
import { useFormikContext } from 'formik'
import type { FocusEvent } from 'react'
import React, { useState } from 'react'

import { Input as InputField, withFormikSupport } from '@fourthwall/components'

import { Info } from '../../components/Info/Info'
import type { Props } from './types'

export const InputComponent = ({
  data,
  value,
  name,
  icon,
  invalid,
  disabled,
  error,
  append,
  onChange,
  onBlur,
  onSettingUpdate,
}: Props) => {
  const { id, label, value: initialValue } = data
  const [lastValue, setLastValue] = useState(initialValue)
  const formik = useFormikContext<FormikValues>()

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(e)
    }

    const targetValue = e.target.value === '' ? undefined : e.target.value

    if (lastValue === targetValue) {
      return
    }

    setLastValue(targetValue)

    if (!(name && formik.errors[name])) {
      onSettingUpdate(id, targetValue)
    }
  }

  return (
    <>
      <InputField
        label={label}
        name={name}
        placeholder={label}
        invalid={invalid}
        disabled={disabled}
        error={error}
        append={append}
        leftIcon={icon}
        value={value}
        onChange={onChange}
        onBlur={handleBlur}
      />
      <Info>{data.info}</Info>
    </>
  )
}

export const Input = withFormikSupport(InputComponent)
